






































import VueOptions from '@utils/VueOptions'

settings =
  name: 'ShippingAreaDisplay'

  resources:
    venues:
      resourceName: 'venue'
      slug: 'suppliers/:supplierId/shipping_areas/:shippingAreaId/venues'
      params:
        quick_list: true
    supplier:
      resourceName: 'supplier'
      slug: 'suppliers/:supplierId'

  vue:
    props: ['shippingArea', 'options']

    computed:
      supplierId: -> @options?.supplierId || @$store.member.supplier.id
      shippingAreaId: -> @shippingArea.id

      shippingAreaVenuesTableData: ->
        for venue in (@venues || [])
          id: venue.id
          data: venue
          name: venue.venue_name
          address: venue.address

export default VueOptions.vue settings
